import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDeleteDialogData {
  title: string;
  message: string;
  itemName: string;
}

@Component({
  standalone: false,
  selector: 'app-confirm-delete-dialog',
  template: `
    <div class="app-dialog-shell">
      <div mat-dialog-title class="app-dialog-shell__header">
        <div class="app-dialog-shell__title-group">
          <div class="app-dialog-shell__title-icon">
            <mat-icon>delete_sweep</mat-icon>
          </div>
          <div class="app-dialog-shell__title-copy">
            <h2 class="app-dialog-shell__title">{{ data.title }}</h2>
            <p class="app-dialog-shell__subtitle">Review this deletion before it is applied.</p>
          </div>
        </div>
        <button mat-icon-button type="button" class="app-dialog-shell__close" (click)="onCancel()" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div mat-dialog-content class="app-dialog-shell__body">
        <p>{{ data.message }}</p>
        <div class="app-dialog-code-block"><code>{{ data.itemName }}</code></div>
        <div class="app-dialog-warning">
          <mat-icon>warning_amber</mat-icon>
          <span>This action cannot be undone.</span>
        </div>
      </div>

      <div mat-dialog-actions class="app-dialog-shell__actions">
        <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="warn" type="button" (click)="onConfirm()">
          <mat-icon>delete_forever</mat-icon>
          Delete
        </button>
      </div>
    </div>
  `,
  styles: [``]
})
export class ConfirmDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
